import {
  ADMIN,
  TEACHER,
  PARENT,
  STUDENT,
  ECE,
  PAGES,
  COMPONENTS
} from '@BUP/constants';

const rules = {
  [PAGES]: {
    HomePage: {
      route: '/',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER]
    },
    ProfilePage: {
      route: '/profile',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER]
    },
    DataPage: {
      route: '/data',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER]
    },
    WebinarsPage: {
      route: '/webinars',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER]
    },
    ResourcesPage: {
      route: '/resources',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER]
    },
    ResourcesByIdPage: {
      route: '/resources/:resourceId',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER]
    },
    TopicsPage: {
      route: '/resources/:resourceId/level/:levelId',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER]
    },
    TopicDetailPage: {
      route: '/resources/:resourceId/level/:levelId/topic/:topicId',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER]
    },
    BupSendPage: {
      route: '/modebup/send',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER]
    },
    BupInboxPage: {
      route: '/modebup/inbox',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER]
    },
    BupDirectPage: {
      route: '/modebup/direct',
      roles: [ADMIN, ECE, PARENT, STUDENT, TEACHER]
    },
    BupArchivedPage: {
      route: '/modebup/archived',
      roles: [ECE, ADMIN]
    },
  },
  [COMPONENTS]: {
    navModeBupSendLink: {
      roles: [PARENT, STUDENT, TEACHER]
    },
    navModeBupArchivedLink: {
      roles: [ADMIN, ECE]
    },
    openOrCloseMessageButton: {
      roles: [ADMIN, ECE]
    },
    messageListStateTag: {
      roles: [PARENT, STUDENT, TEACHER]
    },
    navWebinars: {
      roles: [ADMIN, ECE, PARENT, TEACHER]
    }
  }
};

export const checkPagePermissions = (pageName, userRole, path) => {
  if (!userRole || !pageName || !path) return false;
  const pageRule = rules[PAGES][pageName];
  if (!pageRule) return false;
  const routePermissions = pageRule.route === path
  const pageRoles = pageRule.roles;
  const rolePermissions = pageRoles && pageRoles.includes(userRole);
  // console.log("routePermissions", routePermissions)
  // console.log("rolesPermissions", rolePermissions)
  return routePermissions && rolePermissions;
}

export const checkComponentPermissions = (userRole, componentName) => {
  if(!userRole || !componentName) return false;
  const componentRule = rules[COMPONENTS][componentName];
  if(!componentRule) return false;
  const componentRoles = componentRule.roles;
  //console.log("checkComponentPermissions", userRole, componentName, componentRule)
  const rolePermissions = componentRoles && componentRoles.includes(userRole);
  return rolePermissions
}
